import { buildStepNarration } from './stepNarrationCopy.js'

export const SYNTHETIC_DATA_DEMO_PDF =
  'An_overview_of_large_AI_models_and_their_applicati.pdf'

export const SYNTHETIC_DATA_DEMO_USER_PROMPT =
  'Could synthetic data eventually outperform human-generated data?'

export const SYNTHETIC_DATA_DEMO_THOUGHT_DETAILS = [
  `The user is asking about whether synthetic data could eventually outperform human-generated data. This is a question that likely has relevant content in the uploaded document about large AI models. Let me get the document structure first to find the relevant sections.`,
  `I can see the document structure. The most relevant sections for the question about synthetic data are:

• "Data collection for training" (pages 11–12)
• "Large AI model training" (page 12)

Let me retrieve those pages for more detail on synthetic data.`,
  `The document has relevant content about synthetic data. Let me also check the future trends section (page 16) to see if there's any mention of synthetic data outperforming human-generated data.`,
]

export const SYNTHETIC_DATA_DEMO_WORKFLOW_STEPS = [
  {
    durationMs: 2000,
    actionName: `Read the document structure of "${SYNTHETIC_DATA_DEMO_PDF}"`,
    arguments: { pages: '1–16', sections: ['Data collection for training', 'Large AI model training'] },
    result: { ok: true, nodeIds: ['0023', '0024'] },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Document structure loaded — training-data sections identified on pages 11–12',
      `reading pages 11–12 from ${SYNTHETIC_DATA_DEMO_PDF}`,
      0,
    ),
  },
  {
    durationMs: 2000,
    actionName: `Read pages 11–12 from "${SYNTHETIC_DATA_DEMO_PDF}"`,
    arguments: { pages: '11–12' },
    result: { ok: true, topics: ['virtual simulation', 'generative model synthesis', 'domain-specific gaps'] },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Retrieved synthetic-data strategies from the training-data chapter',
      'drafting the answer from document evidence',
      1,
    ),
  },
]
